(function () {
  var pickerSelector = 'variant-picker[data-sbeauty-kit-required-options="true"]';
  var formSelector = 'product-form-component[data-sbeauty-kit-required-options="true"]';
  var defaultMessage = 'Escolha todas as opções do kit antes de adicionar ao carrinho.';
  var stateByKey = {};

  function sectionIdFor(element) {
    var section = element && element.closest && element.closest('.shopify-section');
    if (!section || !section.id) return '';
    return section.id.replace('shopify-section-', '');
  }

  function stateKey(picker) {
    return [sectionIdFor(picker), picker.dataset.productId || ''].join(':');
  }

  function stateFor(picker) {
    var key = stateKey(picker);
    if (!stateByKey[key]) stateByKey[key] = {};
    return stateByKey[key];
  }

  function groupName(group) {
    var label = group.querySelector('legend, label');
    if (!label) return '';
    var cleanLabel = label.cloneNode(true);
    var swatchValue = cleanLabel.querySelector && cleanLabel.querySelector('.variant-option__swatch-value');
    if (swatchValue) swatchValue.remove();
    return (cleanLabel.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function optionGroups(picker) {
    return Array.prototype.slice
      .call(picker.querySelectorAll('fieldset.variant-option, .variant-option--dropdowns'))
      .filter(function (group) {
        return group.querySelector('input[type="radio"], select');
      });
  }

  function selectedValue(group) {
    var checked = group.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    var select = group.querySelector('select');
    return select ? select.value : '';
  }

  function restoreGroup(group, savedValue) {
    var inputs = Array.prototype.slice.call(group.querySelectorAll('input[type="radio"]'));
    var select = group.querySelector('select');

    inputs.forEach(function (input) {
      var isSaved = Boolean(savedValue) && input.value === savedValue;
      input.checked = isSaved;
      input.dataset.currentChecked = isSaved ? 'true' : 'false';
      input.dataset.previousChecked = 'false';
    });

    if (select) {
      if (!select.querySelector('option[value=""]')) {
        var placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'Escolha uma opção';
        placeholder.disabled = true;
        select.insertBefore(placeholder, select.firstChild);
      }
      select.value = savedValue || '';
      Array.prototype.forEach.call(select.options, function (option) {
        if (option.value === select.value) {
          option.setAttribute('selected', 'selected');
        } else {
          option.removeAttribute('selected');
        }
      });
    }

    var swatchValue = group.querySelector('.variant-option__swatch-value');
    if (swatchValue && !savedValue) swatchValue.textContent = 'Escolha';
  }

  function normalizePicker(picker) {
    if (!picker || picker.dataset.sbeautyKitRequiredOptions !== 'true') return;

    var state = stateFor(picker);
    optionGroups(picker).forEach(function (group) {
      var name = groupName(group);
      restoreGroup(group, state[name]);
      group.classList.toggle('sbeauty-kit-required-missing', picker.dataset.sbeautyKitAttempted === 'true' && !state[name]);
    });

    updateAvailability(picker);
  }

  function missingGroups(picker) {
    var state = stateFor(picker);
    return optionGroups(picker).filter(function (group) {
      return !state[groupName(group)];
    });
  }

  function findPickerForProduct(productId, sectionId) {
    var selector = pickerSelector + '[data-product-id="' + productId + '"]';
    var pickers = Array.prototype.slice.call(document.querySelectorAll(selector));
    return (
      pickers.find(function (picker) {
        return sectionIdFor(picker) === sectionId;
      }) || pickers[0]
    );
  }

  function findMainFormForProduct(productId, sectionId) {
    var selector = formSelector + '[data-product-id="' + productId + '"]';
    var forms = Array.prototype.slice.call(document.querySelectorAll(selector));
    return (
      forms.find(function (form) {
        return sectionIdFor(form) === sectionId;
      }) || forms[0]
    );
  }

  function updateAvailability(picker) {
    var complete = missingGroups(picker).length === 0;
    var productId = picker.dataset.productId || '';
    var sectionId = sectionIdFor(picker);
    var form = findMainFormForProduct(productId, sectionId);
    var accelerated = form && form.querySelector('[ref="acceleratedCheckoutButtonContainer"]');

    picker.dataset.sbeautyKitComplete = complete ? 'true' : 'false';
    if (form) form.dataset.sbeautyKitComplete = complete ? 'true' : 'false';
    if (accelerated) accelerated.hidden = !complete;
  }

  function showMessage(productId, sectionId, missing) {
    var form = findMainFormForProduct(productId, sectionId);
    var picker = findPickerForProduct(productId, sectionId);
    var message = (form && form.dataset.sbeautyKitRequiredMessage) || defaultMessage;
    var names = missing.map(groupName).filter(Boolean);

    if (names.length) message = message + ' Falta escolher: ' + names.join(', ') + '.';

    if (form) {
      var error = form.querySelector('[ref="addToCartTextError"]');
      if (error) {
        error.classList.remove('hidden');
        error.setAttribute('aria-live', 'assertive');
        while (error.childNodes.length > 2) error.removeChild(error.lastChild);
        error.appendChild(document.createTextNode(message));
      }
      var liveRegion = form.querySelector('[ref="liveRegion"]');
      if (liveRegion) liveRegion.textContent = message;
    }

    if (picker) {
      picker.dataset.sbeautyKitAttempted = 'true';
      missing.forEach(function (group) {
        group.classList.add('sbeauty-kit-required-missing');
      });
      var firstMissing = missing[0];
      if (firstMissing && firstMissing.scrollIntoView) {
        firstMissing.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }

  function validateProduct(productId, sectionId) {
    var picker = findPickerForProduct(productId, sectionId);
    if (!picker) return true;

    normalizePicker(picker);
    var missing = missingGroups(picker);
    if (!missing.length) return true;

    showMessage(productId, sectionId, missing);
    return false;
  }

  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;

      var picker = target.closest(pickerSelector);
      if (!picker) return;

      var group = target.closest('fieldset.variant-option, .variant-option--dropdowns');
      if (!group) return;

      var name = groupName(group);
      var value = selectedValue(group);
      if (name && value) stateFor(picker)[name] = value;

      group.classList.remove('sbeauty-kit-required-missing');
      window.setTimeout(function () {
        normalizePicker(picker);
      }, 0);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var stickyButton = target.closest('sticky-add-to-cart[data-sbeauty-kit-required-options="true"] [ref="addToCartButton"]');
      if (stickyButton) {
        var sticky = stickyButton.closest('sticky-add-to-cart');
        if (sticky && !validateProduct(sticky.dataset.productId || '', sectionIdFor(sticky))) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
        return;
      }

      var addButton = target.closest(formSelector + ' button[name="add"]');
      if (!addButton) return;

      var formComponent = addButton.closest(formSelector);
      if (!formComponent || validateProduct(formComponent.dataset.productId || '', sectionIdFor(formComponent))) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      var formComponent = form.closest(formSelector);
      if (!formComponent || validateProduct(formComponent.dataset.productId || '', sectionIdFor(formComponent))) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  function init() {
    document.querySelectorAll(pickerSelector).forEach(normalizePicker);
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('pageshow', init);

  new MutationObserver(function () {
    window.requestAnimationFrame(init);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
